// document.addEventListener("DOMContentLoaded", () => {

//     const section = document.querySelector(".results-study");

//     if (!section) return;

//     const productCards = section.querySelectorAll(".product-card");
//     const studyContents = section.querySelectorAll(".study-content");
//     const studyImages = section.querySelectorAll(".study-image");

//     let activeIndex = 0;

//     function removeActive() {

//         productCards.forEach(card => card.classList.remove("active"));

//         studyContents.forEach(content => {

//             content.classList.add("hidden");

//         });

//         studyImages.forEach(image => {

//             image.classList.add("hidden");

//         });

//     }

//     function activate(index) {

//         removeActive();

//         productCards[index].classList.add("active");

//         studyContents[index].classList.remove("hidden");

//         studyImages[index].classList.remove("hidden");

//         activeIndex = index;

//     }

//     productCards.forEach((card, index) => {

//         card.addEventListener("click", () => {

//             activate(index);

//         });

//     });

//     // Keyboard Accessibility

//     productCards.forEach((card, index) => {

//         card.setAttribute("tabindex", "0");

//         card.addEventListener("keydown", function(e){

//             if(e.key === "Enter" || e.key === " "){

//                 e.preventDefault();

//                 activate(index);

//             }

//         });

//     });

//     // Arrow Key Navigation

//     document.addEventListener("keydown",(e)=>{

//         if(!section.matches(":hover")) return;

//         if(e.key==="ArrowDown"){

//             activeIndex++;

//             if(activeIndex>=productCards.length){

//                 activeIndex=0;

//             }

//             activate(activeIndex);

//         }

//         if(e.key==="ArrowUp"){

//             activeIndex--;

//             if(activeIndex<0){

//                 activeIndex=productCards.length-1;

//             }

//             activate(activeIndex);

//         }

//     });

//     // Swipe Support (Mobile)

//     let touchStart = 0;

//     let touchEnd = 0;

//     section.addEventListener("touchstart",(e)=>{

//         touchStart=e.changedTouches[0].screenX;

//     });

//     section.addEventListener("touchend",(e)=>{

//         touchEnd=e.changedTouches[0].screenX;

//         handleSwipe();

//     });

//     function handleSwipe(){

//         if(Math.abs(touchStart-touchEnd)<50) return;

//         if(touchStart>touchEnd){

//             activeIndex++;

//             if(activeIndex>=productCards.length){

//                 activeIndex=0;

//             }

//         }else{

//             activeIndex--;

//             if(activeIndex<0){

//                 activeIndex=productCards.length-1;

//             }

//         }

//         activate(activeIndex);

//     }

//     // Optional Auto Rotation

//     const autoRotate = false;

//     const delay = 5000;

//     if(autoRotate){

//         setInterval(()=>{

//             activeIndex++;

//             if(activeIndex>=productCards.length){

//                 activeIndex=0;

//             }

//             activate(activeIndex);

//         },delay);

//     }

//     activate(0);

// });
document.addEventListener("DOMContentLoaded", () => {

    const section = document.querySelector(".custom-results-study");

    if (!section) return;

    const productCards = section.querySelectorAll(".custom-results-study .product-card");
    const studyContents = section.querySelectorAll(".custom-results-study .study-content");
    const studyImages = section.querySelectorAll(".custom-results-study .study-image");

    let activeIndex = 0;

    function removeActive() {

        productCards.forEach(card => card.classList.remove("active"));

        studyContents.forEach(content => {
            content.classList.add("hidden");
        });

        studyImages.forEach(image => {
            image.classList.add("hidden");
        });

    }

    function activate(index, shouldScroll = false) {

        removeActive();

        const activeCard = productCards[index];

        activeCard.classList.add("active");

        studyContents[index].classList.remove("hidden");

        studyImages[index].classList.remove("hidden");

        activeIndex = index;

        // Scroll only on mobile
        if (shouldScroll && window.innerWidth <= 767) {

            setTimeout(() => {

                const header =
                    document.querySelector(".shopify-section-header-sticky") ||
                    document.querySelector("#shopify-section-header") ||
                    document.querySelector("header");

                const headerHeight = header ? header.offsetHeight : 80;

                const extraSpace = - 30;

                const targetTop =
                    activeCard.getBoundingClientRect().top +
                    window.pageYOffset -
                    headerHeight -
                    extraSpace;

                window.scrollTo({
                    top: targetTop,
                    behavior: "smooth"
                });

            }, 150);

        }

    }

    // Click
    productCards.forEach((card, index) => {

        card.addEventListener("click", () => {

            activate(index, true);

        });

    });

    // Keyboard Accessibility
    productCards.forEach((card, index) => {

        card.setAttribute("tabindex", "0");

        card.addEventListener("keydown", function (e) {

            if (e.key === "Enter" || e.key === " ") {

                e.preventDefault();

                activate(index, true);

            }

        });

    });

    // Arrow Key Navigation
    document.addEventListener("keydown", (e) => {

        if (!section.matches(":hover")) return;

        if (e.key === "ArrowDown") {

            activeIndex++;

            if (activeIndex >= productCards.length) {
                activeIndex = 0;
            }

            activate(activeIndex);

        }

        if (e.key === "ArrowUp") {

            activeIndex--;

            if (activeIndex < 0) {
                activeIndex = productCards.length - 1;
            }

            activate(activeIndex);

        }

    });

    // Swipe Support
    let touchStart = 0;
    let touchEnd = 0;

    section.addEventListener("touchstart", (e) => {

        touchStart = e.changedTouches[0].screenX;

    });

    section.addEventListener("touchend", (e) => {

        touchEnd = e.changedTouches[0].screenX;

        handleSwipe();

    });

    function handleSwipe() {

        if (Math.abs(touchStart - touchEnd) < 50) return;

        if (touchStart > touchEnd) {

            activeIndex++;

            if (activeIndex >= productCards.length) {
                activeIndex = 0;
            }

        } else {

            activeIndex--;

            if (activeIndex < 0) {
                activeIndex = productCards.length - 1;
            }

        }

        activate(activeIndex, true);

    }

    // Optional Auto Rotation
    const autoRotate = false;
    const delay = 5000;

    if (autoRotate) {

        setInterval(() => {

            activeIndex++;

            if (activeIndex >= productCards.length) {
                activeIndex = 0;
            }

            activate(activeIndex);

        }, delay);

    }

    // Initial Active
    activate(0);

});